import { FilterConfig } from "../../components/Tables/advancedRecord/FilterBar";

/**
 * Construye la configuración de filtros para la gestión de clientes.
 */
export const buildCustomerFilters = (): FilterConfig[] => [
  {
    name: "name",
    label: "Nombre",
    type: "text",
    colSpan: 3,
  },

  {
    name: "nit",
    label: "NIT",
    type: "text",
    colSpan: 2,
  },

  {
    name: "nrc",
    label: "NRC",
    type: "text",
    colSpan: 2,
  },

  {
    name: "dui",
    label: "DUI",
    type: "text",
    colSpan: 2,
  },

  {
    name: "passportNumber",
    label: "Pasaporte",
    type: "text",
    colSpan: 3,
  },

  {
    name: "residentCardNumber",
    label: "Carnet de Residente",
    type: "text",
    colSpan: 4,
  },

  {
    name: "otherIdentification",
    label: "Otra Identificación",
    type: "text",
    colSpan: 4,
  },

  {
    name: "legalName",
    label: "Razón Social",
    type: "text",
    colSpan: 4,
  },

  {
    name: "tradeName",
    label: "Nombre Comercial",
    type: "text",
    colSpan: 4,
  },

  {
    name: "email",
    label: "Correo",
    type: "text",
    colSpan: 4,
  },
];